import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import NavBar from "../components/NavBar";
import PricingAreaOne from "../components/PricingAreaOne";
import NavbarTwo from "../components/NavbarTwo";
import FooterTwo from "../components/FooterTwo";
import ServiceDetailsArea from "../components/ServiceDetailsArea";
import EspaceHnaMeak from "./EspaceHnaMeak";
import { Route, Routes } from "react-router-dom";

const MonEspace = () => {
  return (
    <>
      <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <NavbarTwo />

        
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <EspaceHnaMeak />
        </div>
      </div>
    </>
  );
};

export default MonEspace;
